import { render } from "./StarTabBar.vue?vue&type=template&id=b10a4298&scoped=true&ts=true"
import script from "./StarTabBar.vue?vue&type=script&lang=ts"
export * from "./StarTabBar.vue?vue&type=script&lang=ts"

import "./StarTabBar.vue?vue&type=style&index=0&id=b10a4298&scoped=true&lang=css"
import "./StarTabBar.vue?vue&type=style&index=1&id=b10a4298&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10a4298"]])

export default __exports__